module.exports = __webpack_public_path__ + "static/16.L&G.2023.WINNERS_logos_over£1bn_HSBC-649f5af16ff4af1a052b0ac3d1a6d1c8.png";